export default __webpack_public_path__ + "static/media/inner-timer.52b09a29.svg";